export const CREDIT_REQS = {
  elaCore: {
    humanName: 'ELA',
    gradReq: 8,
  },
  math: {
    humanName: 'Math',
    gradReq: 6,
  },
  ssGlobal: {
    humanName: 'Global',
    gradReq: 4,
  },
  ssUs: {
    humanName: 'US',
    gradReq: 2,
  },
  ssGovt: {
    humanName: 'Govt',
    gradReq: 1,
  },
  ssEcon: {
    humanName: 'Econ',
    gradReq: 1,
  },
  ssGovtEcon: {
    humanName: 'Govt / Econ',
    gradReq: null,
  },
  sciTotal: {
    humanName: 'Sci',
    gradReq: 6,
  },
  sciPhysical: {
    humanName: 'Physical',
    gradReq: 2,
  },
  sciLife: {
    humanName: 'Life',
    gradReq: 2,
  },
  lote: {
    humanName: 'LOTE',
    gradReq: 2,
  },
  cte: {
    humanName: 'CTE',
    gradReq: 0,
  },
  art: {
    humanName: 'Art',
    gradReq: 2,
  },
  pe: {
    humanName: 'PE',
    gradReq: 4,
  },
  health: {
    humanName: 'Health',
    gradReq: 1,
  },
  total: {
    humanName: 'Total',
    gradReq: 44,
  },
};

CREDIT_REQS.ssGovtEcon.gradReq = CREDIT_REQS.ssGovt.gradReq + CREDIT_REQS.ssEcon.gradReq;
